module.exports = __webpack_public_path__ + "img/202104192034581302ct.de29ff77.png";